var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',_vm._b({attrs:{"counter":_setup.counter,"rules":_setup.rules},on:{"change":_setup.onChange},model:{value:(_setup.modelValue),callback:function ($$v) {_setup.modelValue=$$v},expression:"modelValue"}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }